"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoleCollectionAdaptor = void 0;
/**
 * PoleCollectionAdaptor wraps any collection whose form is an IPoleForm.
 */
class PoleCollectionAdaptor {
    constructor(collection, poleForm) {
        this.collection = collection;
        this.poleForm = poleForm;
        if (collection.schema.id !== poleForm.form.id) {
            throw new Error(`The provided poleForm form ID (${poleForm.form.id}) must match the collection's form ID (${collection.schema.id})`);
        }
    }
    get spanField() {
        return this.collection.getField(this.poleForm.spanField.id);
    }
    get spans() {
        return this.spanField.value.map((value) => this.poleForm.spanValue(value));
    }
}
exports.PoleCollectionAdaptor = PoleCollectionAdaptor;
//# sourceMappingURL=IPole.js.map